import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div
      className="mx-auto flex min-h-screen max-w-[1700px] flex-col items-start justify-center px-5 pt-20 sm:px-8 lg:px-16"
      data-testid="payment-cancel-page"
    >
      <XCircle className="h-12 w-12 text-zinc-600" />
      <h1 className="mt-8 font-blackletter text-6xl leading-[1] sm:text-8xl">
        Annulé.
      </h1>
      <p className="mt-6 max-w-md font-serif text-xl italic leading-relaxed text-zinc-400">
        Le checkout a été interrompu. Votre panier vous attend — rien n’a été débité.
      </p>
      <div className="mt-10 flex flex-wrap gap-4">
        <Link
          to="/collections"
          data-testid="payment-cancel-back-link"
          className="flex h-14 items-center bg-ember px-8 font-mono text-[11px] uppercase tracking-[0.3em] text-white transition-colors duration-300 hover:bg-emberhover"
        >
          Retour à la collection
        </Link>
      </div>
    </div>
  );
}
